import axios from '@/plugins/axios';

const evalAgentUrl = '/api/agents';

export const getEvalAgents = async () => {
  const response = await axios.get(evalAgentUrl);
  return response;
};

export const getEvalAgentById = async (id) => {
  const response = await axios.get(`${evalAgentUrl}/${id}`);
  return response;
};

export const createEvalAgent = async (data) => {
  const response = await axios.post(evalAgentUrl, data);
  return response;
};

export const updateEvalAgent = async (id, data) => {
  const response = await axios.patch(`${evalAgentUrl}/${id}`, data);
  return response;
};

export const deleteEvalAgent = async (id) => {
  const response = await axios.post(`${evalAgentUrl}/${id}/delete`);
  return response;
};

export const toggleEvalAgentActive = async (id, currentActive) => {
  const response = await axios.patch(`${evalAgentUrl}/${id}`, {
    active: !currentActive,
  });
  return response;
};
